(function () {
    'use strict';

    angular
        .module('app')
        .controller('testgrid', testgrid);

    testgrid.$inject = ['$location', 'gridDataService', 'columnSetService', '$timeout', '$localStorage']; 

    function testgrid($location, gridDataService, columnSetService, $timeout, $localStorage) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'testgrid';
        vm.gridOptions = {
            
        }
        activate();

        function activate() {
            vm.getPage = function () {
                var results;
                gridDataService.getData(0, 100, "SCHEMA_S_LONGNAME", 1).then(function (response) {
                    results = response;
                    columnSetService.getColumnSetColumns(response.data.ColumnSetId).then(function (response) {
                        var columnDefs = [];                  
                        angular.forEach(response.data, function (item, key) {
                            try {
                                var enableSorting = true;
                                if (item.schemaId == "SCHEMA_S_VERSION") {
                                    enableSorting = false;
                                }
                                var column = {
                                    name: results.data.AdeptDataTable.TableDefinition.fldDefList[item.schemaId].displayName,
                                    field: item.schemaId,
                                    width: item.width,
                                    enableSorting: enableSorting,
                                    bSystem: results.data.AdeptDataTable.TableDefinition.fldDefList[item.schemaId].bSystem
                                }
                                //sort
                                if (item.schemaId == $localStorage.userSettings.gridSort.sort) {
                                    var direction = $localStorage.userSettings.gridSort.direction == 0 ? uiGridConstants.ASC : uiGridConstants.DESC;
                                    column.sort = {
                                        direction: direction,
                                        priority: null
                                    }
                                }
                                column.sortDirectionCycle = ["asc", "desc"];
                                columnDefs.push(column);
                            } catch (e) {
                                console.log("Unable to add column " + item.schemaId + " due to: " + e);
                            }
                        });
                        vm.gridOptions.columnDefs = columnDefs;
                        vm.gridOptions.data = gridDataService.data;

                        vm.processing = false;

                        //refresh the grid
                        $timeout(function () {
                            //vm.gridApi.grid.handleWindowResize();
                            //vm.gridApi.grid.refreshCanvas();
                            //vm.gridApi.grid.refresh();
                        }, 500);
                    });
                });
            }

            vm.getPage();
        }
    }
})();
